import LinkWebsiteConnect from '@/data/linkWebsiteConnect.js';
import { MSEnum } from '@/common/enumeration';
import i18n from '@/i18n/i18n';
export default [{
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceMISA')}`,
        enum: MSEnum.ConnectInvoiceEnum.MeInvoice,
        linkWebsite: 'https://www.meinvoice.vn/tra-cuu/',
        image: require('@/assets/images/icons/meinvoice.png'),
        keyConnect: 'IsConnectedMeInvoice',
        titleOrther: `${i18n.t('i18nConnectInvoice.EmailOrPhoneNumber')}`,
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.InvoiceProvider,
        acronym: ['MISA', 'meInvoice', 'me Invoice']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceGrab')}`,
        enum: MSEnum.ConnectInvoiceEnum.Grab,
        linkWebsite: [
            { display: 'https://vn.einvoice.grab.com', value: 'https://vn.einvoice.grab.com' },
            { display: 'https://vn.invoice.grab.com', value: 'https://vn.invoice.grab.com' }
        ],
        image: require('@/assets/images/icons/grab.png'),
        keyConnect: 'IsConnectedGrab',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['Grab']
    },
    // {
    // 	enum: MSEnum.ConnectInvoiceEnum.HonDa,
    // 	linkWebsite: 'https://eiv.honda.com.vn',
    // 	titleOrther: ''
    // },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceCocaCola')}`,
        enum: MSEnum.ConnectInvoiceEnum.CocaCola,
        linkWebsite: 'https://einvoice.coca-cola.com.vn',
        image: require('@/assets/images/icons/cocacola.png'),
        keyConnect: 'IsConnectedCoca',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: `${i18n.t('i18nConnectInvoice. EmailOrPhoneNumber')}`,
        acronym: ['Coca Cola', 'Coca']
    },
    {
        enum: MSEnum.ConnectInvoiceEnum.Taxaxion,
        linkWebsite: 'https://hoadondientu.gdt.gov.vn',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.Taxaxion,
        titleOrther: ''
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceLavie')}`,
        enum: MSEnum.ConnectInvoiceEnum.Lavie,
        image: require('@/assets/images/icons/lavie.png'),
        keyConnect: 'IsConnectedLavie',
        linkWebsite: 'https://lavie.vnpt-invoice.com.vn',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['Lavie']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceTrungKien')}`,
        enum: MSEnum.ConnectInvoiceEnum.TrungKien,
        linkWebsite: 'https://hoadondientutrungkien.com',
        image: require('@/assets/images/icons/trungkien.png'),
        keyConnect: 'IsConnectedTrungKien',
        titleOrther: '',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.InvoiceProvider,
        acronym: ['Trung Kien']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceEpass')}`,
        enum: MSEnum.ConnectInvoiceEnum.EPass,
        linkWebsite: 'https://customer.epass-vdtc.com.vn/#/login',
        image: require('@/assets/images/icons/logo-epass.png'),
        keyConnect: 'IsConnectedEPass',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['ePass']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceBIDV')}`,
        enum: MSEnum.ConnectInvoiceEnum.BIDV,
        linkWebsite: 'https://einvoice.bidv.com.vn',
        image: require('@/assets/images/icons/logo_BIDV.svg'),
        keyConnect: 'IsConnectedBIDV',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['BIDV']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceVNPT')}`,
        enum: MSEnum.ConnectInvoiceEnum.VNPT,
        linkWebsite: [...LinkWebsiteConnect.VNPT],
        image: require('@/assets/images/icons/logo_VNPT.png'),
        keyConnect: 'IsConnectedVNPT',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['VNPT']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceEVN')}`,
        enum: MSEnum.ConnectInvoiceEnum.EVN,
        linkWebsite: [...LinkWebsiteConnect.EVN],
        image: require('@/assets/images/icons/logo_EVN.png'),
        keyConnect: 'IsConnectedEVN',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['EVN']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceNawasco')}`,
        enum: MSEnum.ConnectInvoiceEnum.Nawasco,
        linkWebsite: 'http://nawasco.com.vn/HoaDonDienTu',
        image: require('@/assets/images/icons/logo_Nawasco.svg'),
        keyConnect: 'IsConnectedNawasco',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['Nawasco']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoicePetrolimex')}`,
        enum: MSEnum.ConnectInvoiceEnum.Petrolimex,
        linkWebsite: 'https://hoadon.petrolimex.com.vn',
        image: require('@/assets/images/icons/logo_PLX.png'),
        keyConnect: 'IsConnectedPetrolimex',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['Petrolimex']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceThuPhiHP')}`,
        enum: MSEnum.ConnectInvoiceEnum.ThuPhiHP,
        linkWebsite: 'https://thuphi.haiphong.gov. vn:8222',
        image: require('@/assets/images/icons/logo_thuphihp.png'),
        keyConnect: 'IsConnectedThuPhiHP',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['Hai Phong', 'Cang vu']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceMSB')}`,
        enum: MSEnum.ConnectInvoiceEnum.MSB,
        linkWebsite: 'https://einvoice.msb.com.vn/Account/LogOn/',
        image: require('@/assets/images/icons/logo_MSB.png'),
        keyConnect: 'IsConnectedMSB',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['MSB']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceVETC')}`,
        enum: MSEnum.ConnectInvoiceEnum.VETC,
        linkWebsite: 'https://customer.vetc.com.vn/',
        image: require('@/assets/images/icons/VETC_logo.png'),
        keyConnect: 'IsConnectedVETC',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: '',
        acronym: ['VETC']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceAEON')}`,
        enum: MSEnum.ConnectInvoiceEnum.AEON,
        linkWebsite: 'https://hddt.aeon.com.vn/dang-nhap',
        image: require('@/assets/images/icons/aeon.png'),
        keyConnect: 'IsConnectedAEON',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: ''
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoicePhuYen')}`,
        enum: MSEnum.ConnectInvoiceEnum.PhuYen,
        linkWebsite: 'https://capthoatnuocpy-tt78.vnpt-invoice.com.vn',
        image: require('@/assets/images/icons/phuyen.png'),
        keyConnect: 'IsConnectedPhuYen',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: ''
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceViettel')}`,
        enum: MSEnum.ConnectInvoiceEnum.Viettel,
        linkWebsite: 'https://vietteltelecom.vn/hoadondientu',
        image: require('@/assets/images/icons/viettel.png'),
        keyConnect: 'IsConnectedViettel',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        titleOrther: `${i18n.t('i18nConnectInvoice.TitleDetailViettel')}`
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceVNPost')}`,
        enum: MSEnum.ConnectInvoiceEnum.VNPost,
        image: require('@/assets/images/icons/vnpost.png'),
        keyConnect: 'IsConnectedVNPost',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        linkWebsite: 'https://hoadon.vnpost.vn/Account/LogOn',
        titleOrther: '',
        acronym: ['Vietnam Post']
    },
    {
        name: `${i18n.t('i18nConnectInvoice.SupplierInvoiceSamsung')}`,
        enum: MSEnum.ConnectInvoiceEnum.SamSung,
        image: require('@/assets/images/icons/samsung.png'),
        keyConnect: 'IsConnectedSamSung',
        typeSupplier: MSEnum.TypeSupplierConnectInvoice.GoodsAndServiceProvider,
        linkWebsite: 'https://tracuu.sseinvoice.vn/dang-nhap',
        titleOrther: ''
    }
];